import {Controller, useFormContext} from "react-hook-form";
import {Select, Checkbox, Collapse} from "antd";
import {
  StyledDiscountFormContainer,
  StyledDiscountFormItem,
} from "../styles/discount-form.styles";
import {useGetOfferings} from "../../../../react-query-hooks/offerings";

export function DiscountCodeOfferingsFormFieldV2() {
  const {control, watch, setValue} = useFormContext();
  const offeringsQuery = useGetOfferings();
  const selectAllOfferings = watch("selectAllOfferings");
  const selectedOfferings = watch("offerings") ?? [];

  const offeringOptions = offeringsQuery.data ?? [];
  const allOfferingValues = offeringOptions.map((opt) => opt.value);
  const selectedOfferingOptions = offeringOptions.filter((opt) =>
    selectedOfferings.includes(opt.value)
  );

  const handleSelectAllChange = (checked: boolean) => {
    setValue("selectAllOfferings", checked);
    if (checked) {
      setValue("offerings", allOfferingValues);
    } else {
      setValue("offerings", []);
    }
  };

  return (
    <StyledDiscountFormContainer>
      <div className="form-header">Offerings</div>
      <div className="form-content">
        <StyledDiscountFormItem>
          <div className="label-row">
            <label>Choose the offering(s) you wish to apply discount to</label>
          </div>
          <Controller
            control={control}
            name="offerings"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <>
                <Select
                  ref={ref}
                  mode="multiple"
                  showSearch
                  maxTagCount={selectAllOfferings ? 0 : "responsive"}
                  maxTagPlaceholder={(omittedValues) =>
                    selectAllOfferings
                      ? `${allOfferingValues.length} offerings selected`
                      : `${omittedValues.length} more`
                  }
                  filterOption={(input, option) =>
                    ((option?.label as string) ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  style={{width: "100%", minHeight: "44px"}}
                  placeholder="Select offering"
                  options={offeringOptions}
                  loading={offeringsQuery.isLoading}
                  disabled={offeringsQuery.isLoading || selectAllOfferings}
                  notFoundContent={
                    offeringsQuery.isLoading
                      ? "Loading offerings..."
                      : "No offerings found"
                  }
                  value={value}
                  onChange={(val) => {
                    onChange(val);
                    if (val.length !== allOfferingValues.length) {
                      setValue("selectAllOfferings", false);
                    }
                  }}
                  onBlur={onBlur}
                  status={error?.message ? "error" : undefined}
                />
                {error && (
                  <div role="alert" className="ant-form-item-explain-error">
                    {error.message}
                  </div>
                )}
              </>
            )}
          />
        </StyledDiscountFormItem>
        <StyledDiscountFormItem style={{marginBottom: 0}}>
          <Checkbox
            checked={selectAllOfferings}
            onChange={(e) => handleSelectAllChange(e.target.checked)}
          >
            Select all offerings
          </Checkbox>
        </StyledDiscountFormItem>
        {selectAllOfferings && selectedOfferingOptions.length > 0 && (
          <StyledDiscountFormItem style={{marginBottom: 0, marginTop: 12}}>
            <Collapse ghost>
              <Collapse.Panel
                header={`${selectedOfferingOptions.length} offerings selected`}
                key="all-selected-offerings"
              >
                <div
                  style={{
                    display: "grid",
                    gap: 8,
                    maxHeight: 220,
                    overflowY: "auto",
                    paddingRight: 4,
                  }}
                >
                  {selectedOfferingOptions.map((offering) => (
                    <div key={offering.value}>{offering.label}</div>
                  ))}
                </div>
              </Collapse.Panel>
            </Collapse>
          </StyledDiscountFormItem>
        )}
      </div>
    </StyledDiscountFormContainer>
  );
}
